import { computed, Injectable, signal } from '@angular/core';

export type RealtimeBootstrapReason = 'login' | 'restore';

export interface RealtimeBootstrapRequest {
  reason: RealtimeBootstrapReason;
  requestedAt: string;
  requestCount: number;
}

@Injectable({ providedIn: 'root' })
export class RealtimeBootstrapCoordinatorService {
  private readonly lastRequestSignal = signal<RealtimeBootstrapRequest | null>(null);

  readonly lastRequest = this.lastRequestSignal.asReadonly();
  readonly lastBootstrapReason = computed<RealtimeBootstrapReason | null>(
    () => this.lastRequestSignal()?.reason ?? null
  );

  requestBootstrap(reason: RealtimeBootstrapReason): void {
    const previousRequest = this.lastRequestSignal();
    this.lastRequestSignal.set({
      reason,
      requestedAt: new Date().toISOString(),
      requestCount: (previousRequest?.requestCount ?? 0) + 1
    });
  }

  clear(): void {
    this.lastRequestSignal.set(null);
  }
}
